import EngineModule                  from '../../../EngineModule';
import { NS as StandingLightningNS } from '../../../components/customers/standing/StandingLighting/StandingLighting';

export default () => new EngineModule.LogicalEngineModule({
	type :             'logical',
	id :               'standing-lighting',
	dependencies :     [
		'oms-basket',
		'viewer-planner',
		'viewer-planner-layout-editor',
		'viewer-planner-dimensionsEditor'
	],
	allowedCustomers : [ /* Local MPA */'XUJG0A2TF5', /* Prod */'STAODAZNIS', 'sam1_12345' ],
	insertionPath :    'K',
	generateComponentConfiguration() : StandingLightningNS.Configuration {
		return {};
	},
	async initialize() {
	}
});
